export const basic = {
  uz: {
    monday: "Dushanba",
    tuesday: "Seshanba",
    wednesday: "Chorshanba",
    thursday: "Payshanba",
    friday: "Juma",
    saturday: "Shanba",
    sunday: "Yakshanba",
  },
  ru: {
    monday: "Понедельник",
    tuesday: "Вторник",
    wednesday: "Среда",
    thursday: "Четверг",
    friday: "Пятница",
    saturday: "Суббота",
    sunday: "Воскресенье",
  },
  tj: {
    monday: "Душанбе",
    tuesday: "Сешанбе",
    wednesday: "Чоршанбе",
    thursday: "Панҷшанбе",
    friday: "Ҷумъа",
    saturday: "Шанбе",
    sunday: "Якшанбе",
  },
};
